import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.vouchers": "Vouchers",
      "nav.orders": "Orders",
      "nav.profile": "Profile",
      "nav.users": "Users",
      "nav.admin": "Admin",
      "nav.logout": "Logout",

      // Common
      "common.loading": "Loading...",
      "common.error": "Error",
      "common.success": "Success",
      "common.cancel": "Cancel",
      "common.confirm": "Confirm",
      "common.save": "Save",
      "common.edit": "Edit",
      "common.delete": "Delete",
      "common.view": "View",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.reset": "Reset",
      "common.submit": "Submit",
      "common.back": "Back",
      "common.next": "Next",
      "common.previous": "Previous",

      // Auth
      "auth.login": "Login",
      "auth.register": "Register",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.firstName": "First Name",
      "auth.lastName": "Last Name",
      "auth.companyName": "Company Name",
      "auth.phone": "Phone",
      "auth.forgotPassword": "Forgot Password?",
      "auth.loginToAccount": "Login to your account",
      "auth.registerAccount": "Create new account",
      "auth.loginSuccess": "Login successful",
      "auth.registerSuccess": "Registration successful",

      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.welcome": "Welcome back",
      "dashboard.totalOrders": "Total Orders",
      "dashboard.pendingOrders": "Pending Orders",
      "dashboard.totalSpent": "Total Spent",
      "dashboard.availableCredit": "Available Credit",
      "dashboard.recentOrders": "Recent Orders",
      "dashboard.quickActions": "Quick Actions",

      // Vouchers
      "vouchers.title": "Vouchers",
      "vouchers.browse": "Browse Vouchers",
      "vouchers.category": "Category",
      "vouchers.brand": "Brand",
      "vouchers.country": "Country",
      "vouchers.priceRange": "Price Range",
      "vouchers.basePrice": "Face Value",
      "vouchers.yourPrice": "Your Price",
      "vouchers.available": "In Stock",
      "vouchers.moq": "Minimum Order",
      "vouchers.viewDetails": "View Details",

      // Orders
      "orders.title": "Orders",
      "orders.orderNumber": "Order Number",
      "orders.date": "Date",
      "orders.status": "Status",
      "orders.amount": "Amount",
      "orders.items": "Items",
      "orders.downloadCodes": "Download Codes",
      "orders.viewOrder": "View Order",
      "orders.cancelOrder": "Cancel Order",

      // Profile
      "profile.title": "Profile",
      "profile.companyInfo": "Company Information",
      "profile.contactInfo": "Contact Information",
      "profile.billingInfo": "Billing Information",
      "profile.creditInfo": "Credit Information",
      "profile.changePassword": "Change Password",

      // Status
      "status.pending": "Pending",
      "status.confirmed": "Confirmed",
      "status.processing": "Processing",
      "status.fulfilled": "Fulfilled",
      "status.cancelled": "Cancelled",
      "status.paid": "Paid",
      "status.overdue": "Overdue",

      // Validation
      "validation.required": "This field is required",
      "validation.email": "Please enter a valid email",
      "validation.minLength": "Minimum {{count}} characters required",
      "validation.passwordMatch": "Passwords do not match"
    }
  }
  // Add more languages as needed
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
